/* eslint-disable react/no-multi-comp */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-sort-props */
/* eslint-disable react/jsx-max-props-per-line */
import React, { useState } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { makeStyles } from '@material-ui/styles';
import { TableCell, Grid, DialogContentText } from '@material-ui/core';
import { Table, DialogDefault, CustomFilter } from '../../components';
import * as selectorsAuth from '../../store/auth/reducer';
import Formulario from './Formulario';
import { isNotAdmin } from 'utils';
import * as Roles from '../../constants/role';
import moment from 'moment';

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3)
  },
}));

const defaultFilter = authData => ({ 
  inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
  fim: moment().endOf('month').valueOf(),
  usuarioId: isNotAdmin(authData.role) ? [authData.id] : [],
  modulos: [],
  tipoServicos: [],
  status: [],
})

const ProcedimentoNorma = ({ authData }) => {
  const [open, setOpen] = useState(false);
  const [id, setId] = useState(null);
  const [localFilter, setLocalFilter] = useState({
    inicio: moment().subtract(1, 'month').startOf('month').valueOf(),
    fim: moment().endOf('month').valueOf(),
  });
  const [reload, setReload] = useState(false);
  const [openExport, setOpenExport] = useState(false);

  const classes = useStyles();
  
  const renderRows = d => {
    return (
      <>
        <TableCell>
          {d.title}
          <br />
          <span style={{ fontSize: 12, fontWeight: 'bold' }}> Criado em </span>
          <span style={{ fontSize: 12 }}> {d.dataInclusaoValue} </span>
        </TableCell>
        <TableCell>
          {d.moduloNome}
          <>
            {d.tipoServicoNome && <>
              <br />
              <span style={{ fontSize: 12, fontWeight: 'bold' }}> Tipo de Serviço: </span>
              <span style={{ fontSize: 12 }}> {d.tipoServicoNome} </span>
            </>}
            {d.subtipoNome && <>
              <br />
              <span style={{ fontSize: 12, fontWeight: 'bold' }}> Subtipo: </span>
              <span style={{ fontSize: 12 }}> {d.subtipoNome} </span>
            </>}
          </>
        </TableCell>
        <TableCell>{d.usuarioNome}</TableCell>
        <TableCell>
          {d.statusValue}
          <>
            {d.status === "CANCEL" && <>
              <br />
              <span style={{ fontSize: 12, fontWeight: 'bold' }}> Cancelado em </span>
              <span style={{ fontSize: 12 }}> {d.dataCanceladaValue} </span>
            </>}
            {d.status === "ACCEPTED" && <>
              <br />
              <span style={{ fontSize: 12, fontWeight: 'bold' }}> Confirmado em </span>
              <span style={{ fontSize: 12 }}> {d.dataConfirmacaoValue} </span>
            </>}
          </>
        </TableCell>
      </>
    )
  }

  const onEdit = id => {
    setOpen(true);
    setId(id);
  }

  const onAdd = () => {
    setOpen(true);
    setId(null);
  }

  const onClose = (save) => {
    setOpen(false);
    setId(null);
    if (save) {
      setReload(!reload);
    }
  }

  const isAdmin = () => authData && (authData.role === Roles.ADMIN || authData.role === Roles.SUPER_ADMIN);

  const getHeaderActions = () => {
    let actions = [];

    // if (isAdmin()) {
    //   actions.push({ 
    //     title: 'Relatório',
    //     onClick: () => setOpenExport(true)
    //   });
    // }

    return actions;
  }

  return (
    <Grid container>
      <Grid item xs={12}>
        <CustomFilter
          onFilter={filterData => setLocalFilter(filterData)}
          fields={[
            { field: "useUsuarios", md: 6, xs: 6, multiSelect: true, disabled: (Roles.ADMIN !== authData.role && Roles.SUPER_ADMIN !== authData.role) },
            { field: "useOption", md: 6, xs: 6, code: "PROCEDIMENTOS_NORMAS_MODULOS", label: "Módulos", key: "modulos" },
            { field: "useTipoServico", md: 6, xs: 6 },
            { field: "useMultiSelectCustomOption", md: 6, xs: 6, label: "Status", key: "status", options: [
                {'value': 'ACCEPTED', label: 'Confirmado'},
                {'value': 'AVAILABLE', label: 'Aguardando Confirmação'},
                {'value': 'CANCEL', label: 'Cancelado'},
            ]},
          ]}
          defaultFilter={defaultFilter(authData)}
        />
      </Grid>
      <Grid item xs={12} className={classes.root}>
        <Table 
          titles={['Título', 'Módulo', 'Usuário', 'Status']}
          headerTitle="Procedimentos e Normas"
          renderRows={renderRows}
          hasRowActions
          onEdit={onEdit}
          onAdd={onAdd}
          headerActions={getHeaderActions()}
          showDelete={false}
          usePaginationApi
          paginationApi="procedimentos-normas/filter"
          paginationUrl="procedimentos-normas"
          filterData={localFilter}
          reload={!reload}
        />
        <Formulario
          id={id}
          open={open}
          onClose={onClose}
          onReload={() => setReload(!reload)}
        />
        <DialogDefault
          open={openExport}
          useFullScreen={false}
          handlerCancel={() => setOpenExport(false)}
          handlerConfirm={() => {
            convocacaoReport(localFilter, () => {
              setOpenExport(false);
            });
          }}
          title="Confirmação"
          confirmMessage="Sim"
          cancelMessage="Não"
        >
          <DialogContentText> Deseja baixar todas as informações filtradas? </DialogContentText>
        </DialogDefault>
      </Grid>
    </Grid>
  );
};

const mapStateToProps = state => ({
  authData: selectorsAuth.getAuth(state)
});

export default connect(mapStateToProps, null)(withRouter(ProcedimentoNorma));